import React, { useEffect, useState } from 'react'
import './profilePage.scss'
import { useDispatch, useSelector } from 'react-redux'
import { Button, theme } from 'antd'
import { Content } from 'antd/es/layout/layout'
import Menu from 'antd/es/menu'
import {
  BankTwoTone,
  GoldTwoTone,
  ProfileTwoTone,
  FileTextTwoTone,
  PrinterTwoTone
} from '@ant-design/icons'
import ProfileComponent from '../../Components/ProfileComponents/profile/profile.component'
import RestaurantComponent from '../../Components/ProfileComponents/restaurant/restaurant.component'
import CriticalInfoComponent from '../../Components/ProfileComponents/criticalInfo/criticalinfo.component'
import DocumentsComponent from '../../Components/ProfileComponents/documents/documents.component'
import PrintersComponent from '../../Components/ProfileComponents/printers/printers.component'
import { SetVendorInfo } from '../../redux/userredux/user_slice'
import { axiosInstance } from '../../interceptor/axios_interceptor'
const ProfilePage = () => {
  const [viewPage, setViewPage] = useState('profile')
  const [vendorDetails, setVendorDetails] = useState()
  const [vendorInfoLoaded, SetVendorInfoLoaded] = useState(false)
  const reduxUser = useSelector((state: any) => state.user)
  const dispatch = useDispatch()
  const {
    token: { colorBgContainer }
  } = theme.useToken()
  const updateVendorInfo = (vendorUpdatedDetails: any) => {
    console.log(vendorUpdatedDetails)
    dispatch(SetVendorInfo({ vendorInfo: vendorUpdatedDetails }))
  }
  const items = [
    { key: 'profile', label: 'Profile', icon: <ProfileTwoTone /> },
    { key: 'restaurant', label: 'Restaurant', icon: <GoldTwoTone /> },
    { key: 'criticalInfo', label: 'Critical Info', icon: <BankTwoTone /> },
    { key: 'documents', label: 'Documents', icon: <FileTextTwoTone /> },
    { key: 'printers', label: 'Printers', icon: <PrinterTwoTone /> }
  ]

  useEffect(() => {
    setVendorDetails(JSON.parse(JSON.stringify(reduxUser.vendorInfo)))
    SetVendorInfoLoaded(true)
  }, [reduxUser])

  const pageSelected = ({ key }: any) => {
    setViewPage(key)
  }

  const updatedDetails = async () => {
    try {
      const payload = { ...(vendorDetails || {}) } as any
      Object.hasOwn(payload, 'live') ? delete payload.live : null

      const response = await axiosInstance.post(
        '/api/vendor/updateVendorDetails/',
        payload
      )
      if (response.data.responseCode === 0) {
        alert(response.data.response)
      }
    } catch (error) {
      console.log(error)
      alert(error)
    }
  }

  const renderContent = () => {
    switch (viewPage) {
      case 'profile':
        return (
          <ProfileComponent
            vendorDetails={vendorDetails}
            updateVendorInfo={updateVendorInfo}
          />
        )
      case 'restaurant':
        return (
          <RestaurantComponent
            vendorDetails={vendorDetails}
            updateVendorInfo={updateVendorInfo}
          />
        )
      case 'criticalInfo':
        return (
          <CriticalInfoComponent
            vendorDetails={vendorDetails}
            updateVendorInfo={updateVendorInfo}
          />
        )
      case 'documents':
        return (
          <DocumentsComponent
            vendorDetails={vendorDetails}
            updateVendorInfo={updateVendorInfo}
          />
        )
      case 'printers':
        return <PrintersComponent />
      default:
        return <div>Page Not Found</div>
    }
  }

  return (
    <>
      <div className='profile_container'>
        <div className="profile-nav-container">
          <Menu
            mode='horizontal'
            defaultSelectedKeys={['2']}
            defaultOpenKeys={['']}
            className="profile-menu"
            theme='dark'
            onClick={pageSelected}
            items={items}
          />
          <Button color='primary' type='primary' onClick={updatedDetails}>
            Update Details
          </Button>
        </div>

        <Content
          style={{ position: 'relative', overflow: 'initial', width: '100%' }}
        >
          {vendorInfoLoaded && renderContent()}
        </Content>
      </div>
    </>
  )
}

export default ProfilePage
